import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowFilledRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 12,
	viewBox: "0 0 10 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.17337 11.9931C1.10028 12.0021 0.942819 12.0025 0.870378 11.9931C0.292372 11.9183 0.0247326 11.2538 0.00477891 10.6928C0.0223468 7.47873 -0.0316582 4.25875 0.0321068 1.04816C0.186097 -0.0183547 1.00767 -0.246962 1.81579 0.253204C4.38548 1.88209 7.00462 3.42694 9.55088 5.09432C10.1499 5.64518 10.1495 6.34814 9.55088 6.89853C6.89032 8.60839 4.19809 10.284 1.48764 11.9C1.39351 11.9267 1.26663 11.9819 1.17337 11.9931Z",
		fill: "currentColor"
	})
});
export default SvgArrowFilledRight;
